import { TYPE_LABELS } from 'lib/constants/transaction/typeLabels';
import { formatDate } from 'lib/helpers/dateUtils';
import { inRn, mString } from 'lib/helpers/utility';

import Status from 'components/shared/Status/Status';

export const TRANSACTIONS_TABLE_COLUMNS = (timezone) => [
  {
    headerName: 'Date',
    field: 'created_at',
    valueFormatter: ({ value }) => formatDate(value, timezone, 'MM/dd/yyyy h:mm a')
  },
  {
    headerName: 'Type',
    field: 'type',
    valueFormatter: ({ value }) => TYPE_LABELS[value] || value || '-'
  },
  {
    headerName: 'Status',
    field: 'status',
    cellRenderer: ({ value }) => <Status status={value} size="small" />
  },
  {
    headerName: 'Amount',
    field: 'amount_paid_self',
    valueFormatter: ({ data }) =>
      mString(inRn(data?.amount_paid_self) - inRn(data?.surcharge_amount))
  },
  {
    headerName: 'Tech. fee',
    field: 'surcharge_amount',
    valueFormatter: ({ value }) => mString(inRn(value, 0))
  },
  {
    headerName: 'Total',
    field: 'amount_total',
    valueFormatter: ({ data }) => mString(inRn(data?.amount_paid_self, 0))
  }
];
